export const MaintenanceStatus = {
  Normal: 1,
  MessageOnly: 2,
  StopLogin: 3,
}
